import script from "./PrePourMedRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./PrePourMedRecord.vue?vue&type=script&setup=true&lang=js"

import "./PrePourMedRecord.vue?vue&type=style&index=0&id=628e5722&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628e5722"]])

export default __exports__